// src/services/supabase.ts
import { createClient, SupabaseClient } from "@supabase/supabase-js";
import { ENV } from "../config/environment";
import { Database } from "../types/supabase.types";

let supabaseInstance: SupabaseClient<Database> | null = null;

export const getSupabaseClient = (): SupabaseClient<Database> => {
  if (!supabaseInstance) {
    supabaseInstance = createClient<Database>(
      ENV.SUPABASE_URL,
      ENV.SUPABASE_ANON_KEY,
      {
        auth: {
          persistSession: true,
          autoRefreshToken: true,
          detectSessionInUrl: true,
        },
        global: {
          headers: {
            "x-application-name": ENV.APP_NAME,
          },
        },
        db: {
          schema: "public",
        },
        realtime: {
          params: {
            eventsPerSecond: 10,
          },
        },
      },
    );
  }
  return supabaseInstance;
};

export const supabase = getSupabaseClient();
export default supabase;
